// extracted by mini-css-extract-plugin
module.exports = {"bubble":"_2Jq5S","content":"CeY49","triangleWrapper":"_2EL2A","triangle":"-HyA7"};